import {FETCH_CHART_DEVICE_DATA_REQUEST, FETCH_TIME_LINE_DEVICE_DATA_REQUEST, FETCH_POWER_METER_DAY_DATA_REQUEST, FETCH_POWER_METER_MONTH_DATA_REQUEST, EXPORT_DEVICE_DATA_REQUEST} from './constants'

export function fetchChartDeviceData(device, timeQuery, from, to, offset, limit) {
  return {
    type: FETCH_CHART_DEVICE_DATA_REQUEST,
    device,
    timeQuery,
    from,
    to,
    offset,
    limit
  }
}

export function fetchTimeLineDeviceData(device, timeQuery, from, to, offset, limit) {
  return {
    type: FETCH_TIME_LINE_DEVICE_DATA_REQUEST,
    device,
    timeQuery,
    from,
    to,
    offset,
    limit
  }
}

export function fetchChartPowerMeterDayData(device, timeQuery, from, to, offset, limit) {
  return {
    type: FETCH_POWER_METER_DAY_DATA_REQUEST,
    device,
    timeQuery,
    from,
    to,
    offset,
    limit
  }
}

export function fetchChartPowerMeterMonthData(device, timeQuery, from, to, offset, limit) {
  return {
    type: FETCH_POWER_METER_MONTH_DATA_REQUEST,
    device,
    timeQuery,
    from,
    to,
    offset,
    limit
  }
}

export function exportDeviceData(device, timeQuery, from, to){
  return {
    type: EXPORT_DEVICE_DATA_REQUEST,
    device,
    timeQuery,
    from,
    to
  }
}



// WEBPACK FOOTER //
// ./src/actions/chart.js